// extracted by mini-css-extract-plugin
module.exports = {"downloadLink":"PhoneConnected_downloadLink_3f2cw"};